import React from "react";
import { motion } from "framer-motion";
import PhotoSection from "./PhotoSection";
import Menu from "./Menu";
import TimeLine from "./about/TimeLine";
import Slider from "./about/Slider";
import ProjectCard from "./about/ProjectCard";
import ReactParallaxTilt from "react-parallax-tilt";

const About = () => {
  return (
    <motion.div
      className=" select-none scroll h-max  transition-all duration-300 p-4 px-6 flex-grow"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="font-bold font-poppins text-2xl transition-all duration-300 sx:text-xl"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        About
      </motion.div>
      <motion.p
        className="font-lora font-normal text-pretty sx:text-base text-md transition-all duration-300"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <p>
          I am a skilled Full Stack Developer and Competitive Programmer with
          extensive experience in web development using ReactJS, NextJS, and
          NodeJS. I have built several full stack applications and have a strong
          proficiency in Python.
          <br />
          <p className="font-bold my-4 text-lg">{process.env.REACT_APP_TAG}</p>
        </p>
      </motion.p>
      <Slider />
      <motion.div
        className="flex flex-wrap w-full gap-y-48 max-h-full"
        initial={{ opacity: 0, y: -5000 }}
        animate={{ opacity: 1, y: 0, animationDelay: 0.5 }}
      >
        <TimeLine />
        <ProjectCard />
      </motion.div>
    </motion.div>
  );
};

export default About;
